// Cart Simple JavaScript - Handle quantity updates and cart interactions

function updateCartQuantity(input, change) {
  const variantId = input.dataset.variantId;
  const inventoryQuantity = parseInt(input.dataset.inventoryQuantity) || 0;
  const inventoryManagement = input.dataset.inventoryManagement;
  const inventoryPolicy = input.dataset.inventoryPolicy;
  let newQuantity;
  const maxQuantityRule = input.dataset.max;
  const minQuantityRule = input.dataset.min;
  
  if (change === 0) {
    // Direct input change
    newQuantity = parseInt(input.value) || minQuantityRule;
  } else {
    // Button click
    newQuantity = parseInt(input.value) + change;
  }
  
  // Check stock availability
  const checkStock = inventoryManagement === 'shopify' && inventoryPolicy !== 'continue';
  const maxAvailable = checkStock ? Math.min(maxQuantityRule, inventoryQuantity) : maxQuantityRule;
  
  // Show stock warning if quantity exceeds available stock
  if (checkStock && newQuantity > inventoryQuantity) {
    showStockWarning(input, inventoryQuantity, newQuantity);
    newQuantity = inventoryQuantity; // Limit to available stock
  } else {
    hideStockWarning(variantId);
  }
  
  // Ensure quantity is at least 1 and maximum available
  if (newQuantity < minQuantityRule) newQuantity = minQuantityRule;
  if (newQuantity > maxAvailable) newQuantity = maxAvailable;
  
  // Update input value
  input.value = newQuantity;
  
  // Update button states
  updateButtonStates(input);
  
  // Don't call API here - just update UI
  // API will be called when user clicks "UPDATE CART" button
}

function updateButtonStates(input) {
  const quantity = parseInt(input.value);
  const minusButton = input.parentElement.querySelector('.quantity-simple__button--minus');
  const plusButton = input.parentElement.querySelector('.quantity-simple__button--plus');
  
  // Check if we should limit based on stock
  const maxAvailable = input.dataset.max;
  const minAvailable = input.dataset.min;
  
  // Disable minus button when quantity is 1
  if (quantity <= minAvailable) {
    minusButton.disabled = true;
    minusButton.classList.add('disabled');
  } else {
    minusButton.disabled = false;
    minusButton.classList.remove('disabled');
  }
  
  // Disable plus button when quantity reaches maximum available
  if (quantity >= maxAvailable) {
    plusButton.disabled = true;
    plusButton.classList.add('disabled');
  } else {
    plusButton.disabled = false;
    plusButton.classList.remove('disabled');
  }
}

function showStockWarning(input, availableStock, requestedQuantity) {
  const productTitle = input.dataset.productTitle;
  const variantId = input.dataset.variantId;
  
  // Find the warning element in cart footer
  const warningElement = document.getElementById(`stock-warning-${variantId}`);
  if (!warningElement) return;
  
  const messageElement = warningElement.querySelector('.product-form__error-message');
  const message = `Only ${availableStock} items were added to your cart due to availability.`;
  
  messageElement.textContent = message;
  warningElement.style.display = 'flex';
}

function hideStockWarning(variantId) {
  const warningElement = document.getElementById(`stock-warning-${variantId}`);
  if (warningElement) {
    warningElement.style.display = 'none';
  }
}

function handleCartErrors(input, errors) {
  const variantId = input.dataset.variantId;
  const warningElement = document.getElementById(`stock-warning-${variantId}`);
  
  if (!warningElement) return;
  
  // Show the first error message
  if (errors.length > 0) {
    const messageElement = warningElement.querySelector('.product-form__error-message');
    messageElement.textContent = errors[0];
    warningElement.style.display = 'flex';
    
    // Auto-hide after 5 seconds
    setTimeout(() => {
      hideStockWarning(variantId);
    }, 5000);
  }
}

function updateCartFromForm() {
  const form = document.getElementById('cart');
  const updateButton = document.querySelector('.cart-footer-simple__button--update');
  const quantityInputs = form.querySelectorAll('.quantity-simple__input');
  const updates = {};
  
  // Show loading state
  const originalButtonText = updateButton.innerHTML;
  updateButton.disabled = true;
  
  // Collect all quantity updates from form
  quantityInputs.forEach(input => {
    const variantId = input.dataset.variantId;
    const quantity = parseInt(input.value) || input.dataset.min;
    updates[variantId] = quantity;
  });

  
  // Update cart via AJAX
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ updates })
  })
  .then(response => response.json())
  .then(cart => {
    
    // Update prices in the UI
    updateCartPrices(cart);
    
    // Update continue shopping button
    updateContinueShoppingButton();
    
    // Update cart count in header
    updateCartCount(cart);
    
    // Restore button state
    updateButton.innerHTML = originalButtonText;
    updateButton.disabled = false;
    // location.reload();
  })
  .catch(error => {
    console.error('Error updating cart:', error);
    
    // Restore button state
    updateButton.innerHTML = originalButtonText;
    updateButton.disabled = false;
  });
}

// Store product URL for continue shopping button
let continueShoppingUrl = null;

function formatMoney(cents, format = "{{amount}}") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) return 0;

    number = (number / 100.0).toFixed(precision);

    let parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents = parts[1] ? (decimal + parts[1]) : "";

    return dollars + cents;
  }

  // Check if the amount is a whole number (no cents)
  const isWholeNumber = (cents % 100) === 0;

  switch (format.match(placeholderRegex)[1]) {
    case "amount":
      // Use 0 decimal places for whole numbers, 2 for amounts with cents
      value = formatWithDelimiters(cents, isWholeNumber ? 0 : 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, isWholeNumber ? 0 : 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return format.replace(placeholderRegex, value);
}


function updateCartPrices(cart) {
  
  // Update individual item prices
  cart.items.forEach(item => {
    const itemElement = document.querySelector(`[data-variant-id="${item.variant_id}"]`);
    if (itemElement) {
      const priceElement = itemElement.closest('.cart-item-simple').querySelector('.cart-item-simple__price');
      if (priceElement) {
        // Convert cents to dollars and format with thousand separators
        const formattedPrice = formatMoney(item.line_price);
        // Keep the original currency symbol from the element
        const originalText = priceElement.textContent;
        const currencyMatch = originalText.match(/[^\d\s,.-]+/);
        const currencySymbol = currencyMatch ? currencyMatch[0] : '$';
        
        priceElement.textContent = currencySymbol + formattedPrice;
      }
    }
  });
  
  // Update subtotal
  const subtotalElement = document.querySelector('.cart-footer-simple__subtotal-value');
  if (subtotalElement) {
    const formattedTotal = formatMoney(cart.total_price);
    // Keep the original currency symbol from the element
    const originalText = subtotalElement.textContent;
    const currencyMatch = originalText.match(/[^\d\s,.-]+/);
    const currencySymbol = currencyMatch ? currencyMatch[0] : '$';
    
    subtotalElement.textContent = currencySymbol + formattedTotal;
  }
  
}

function updateCartCount(cart) {
  // Update cart count in header - only update values, don't change styles
  const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart-count, [data-cart-count]');
  const totalItems = cart.item_count;
  
  
  cartCountElements.forEach(element => {
    element.textContent = totalItems;
    element.setAttribute('data-cart-count', totalItems);
  });
  
  // Also update any cart icon bubbles
  const cartBubbles = document.querySelectorAll('.cart-icon-bubble');
  cartBubbles.forEach(bubble => {
    const countElement = bubble.querySelector('.cart-count-bubble, .cart-count');
    if (countElement) {
      countElement.textContent = totalItems;
      countElement.setAttribute('data-cart-count', totalItems);
    }
  });
  
}

function getFirstCartItemUrl() {
  // Get the first item from cart and return its product URL
  const firstCartItem = document.querySelector('.cart-item-simple');
  if (firstCartItem) {
    const productLink = firstCartItem.querySelector('.cart-item-simple__name');
    if (productLink) {
      return productLink.href;
    }
  }
  return null;
}

function updateContinueShoppingButton() {
  // Update both continue shopping buttons
  const continueButtons = document.querySelectorAll('.cart-footer-simple__button--continue, #continue-shopping-empty-btn');
  
  
  // Determine the URL to use
  let targetUrl = null;
  
  // Check if cart has items
  const cartItems = document.querySelectorAll('.cart-item-simple');
 
  
  if (cartItems.length > 0) {
    // Cart has items - use first item's product URL
    targetUrl = getFirstCartItemUrl();

  } else {
    // Cart is empty - use saved URL or fallback
    targetUrl = continueShoppingUrl || '/collections/all';
    console.log('Cart empty, using saved URL or fallback:', targetUrl);
  }
  
  continueButtons.forEach(button => {
    button.href = targetUrl;
  });
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  const currentUrl = window.location.href;
  
  // Theme settings are now available from theme.liquid
  
  // Load saved URL on page load
  const savedUrl = localStorage.getItem('lastAddedProductUrl');
  if (savedUrl) {
    continueShoppingUrl = savedUrl;
  }
  
  // Handle different scenarios for setting continue shopping URL
  if (currentUrl.includes('/products/')) {
    // User is on a product page - save this URL
    continueShoppingUrl = currentUrl;
    localStorage.setItem('lastAddedProductUrl', continueShoppingUrl);
   
  } else if (currentUrl.includes('/cart')) {
    // User is on cart page
    if (document.referrer && document.referrer.includes('/products/')) {
      // Came from a product page - save referrer URL
      continueShoppingUrl = document.referrer;
      localStorage.setItem('lastAddedProductUrl', continueShoppingUrl);
     
    }
    // If came from cart icon or other source, use saved URL or fallback
  }
  
  // Update continue shopping button
  updateContinueShoppingButton();
  
  // Also update when cart changes (like when items are removed)
  // This will be called on every page load to ensure button is always correct
  setTimeout(() => {
    updateContinueShoppingButton();
  }, 100);
  
  // Subscribe to cart update events to track product additions
  if (typeof subscribe !== 'undefined') {
    subscribe('cart-update', function(event) {
      console.log('Cart update event received:', event);
      if (event.productVariantId) {
        const currentUrl = window.location.href;
        if (currentUrl.includes('/products/')) {
          // If we're on a product page, save this URL
          continueShoppingUrl = currentUrl;
          localStorage.setItem('lastAddedProductUrl', continueShoppingUrl);
        }
      }
    });
  }
  // Initialize button states for all quantity inputs
  const quantityInputs = document.querySelectorAll('.quantity-simple__input');
  quantityInputs.forEach(input => {
    // Add beforeinput event listener to prevent non-numeric input at the source
    input.addEventListener('beforeinput', function(e) {
      // Allow: backspace, delete, tab, escape, enter, and control keys
      if (e.inputType === 'deleteContentBackward' || 
          e.inputType === 'deleteContentForward' ||
          e.inputType === 'insertLineBreak' ||
          e.inputType === 'insertTab' ||
          e.ctrlKey || e.metaKey) {
        return;
      }
      
      // Block any input that is not a digit
      if (e.data && !/^[0-9]$/.test(e.data)) {
        e.preventDefault();
      }
    });
    
    // Add keydown event listener to block non-numeric keys
    input.addEventListener('keydown', function(e) {
      // Allow: backspace, delete, tab, escape, enter, arrow keys
      if ([8, 9, 27, 13, 46, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
          // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z
          (e.ctrlKey && [65, 67, 86, 88, 90].indexOf(e.keyCode) !== -1)) {
        return;
      }
      
      // Block everything else except numbers (0-9)
      if (e.keyCode < 48 || e.keyCode > 57) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
    
    // Add compositionstart event to block IME input (for Vietnamese, Chinese, etc.)
    input.addEventListener('compositionstart', function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    
    // Add compositionupdate event to block IME input
    input.addEventListener('compositionupdate', function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    
    // Add compositionend event to block IME input
    input.addEventListener('compositionend', function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
    
    // Add keypress event listener as backup
    input.addEventListener('keypress', function(e) {
      // Allow: backspace, delete, tab, escape, enter
      if ([8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
          // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
          (e.keyCode === 65 && e.ctrlKey === true) ||
          (e.keyCode === 67 && e.ctrlKey === true) ||
          (e.keyCode === 86 && e.ctrlKey === true) ||
          (e.keyCode === 88 && e.ctrlKey === true)) {
        return;
      }
      // Only allow numbers (0-9) - block everything else including accented characters
      if (e.keyCode < 48 || e.keyCode > 57) {
        e.preventDefault();
      }
    });
    
    // Add paste event listener to filter pasted content
    input.addEventListener('paste', function(e) {
      e.preventDefault();
      const paste = (e.clipboardData || window.clipboardData).getData('text');
      const numericValue = paste.replace(/[^0-9]/g, '');
      if (numericValue) {
        input.value = numericValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    
    // Add input event listener to remove any non-numeric characters
    input.addEventListener('input', function(e) {
      const value = e.target.value;
      // Remove any character that is not a digit
      const numericValue = value.replace(/[^0-9]/g, '');
      
      // If the value was changed (non-numeric characters removed), update the input
      if (value !== numericValue) {
        e.target.value = numericValue;
      }
      
      // Don't mark input as changed - keep UI unchanged
      
      // Check stock in real-time
      const inventoryQuantity = parseInt(e.target.dataset.inventoryQuantity) || 0;
      const inventoryManagement = e.target.dataset.inventoryManagement;
      const inventoryPolicy = e.target.dataset.inventoryPolicy;
      const checkStock = inventoryManagement === 'shopify' && inventoryPolicy !== 'continue';
      
      if (checkStock && parseInt(e.target.value) > inventoryQuantity) {
        showStockWarning(e.target, inventoryQuantity, parseInt(e.target.value));
      } else {
        hideStockWarning(e.target.dataset.variantId);
      }
    });
    
    updateButtonStates(input);
  });
  
  console.log('Cart Simple JS loaded');
});
